export const ADD_COMMENT = 'ADD_COMMENT';
export const DISHES_LOADING = 'DISHES_LOADING';
export const DISHES_FAILED = 'DISHES_FAILED';
export const ADD_DISHES = 'ADD_DISHES';
export const UPDATE_NUMBER_RIGHT = 'UPDATE_NUMBER_RIGHT';
export const UPDATE_NUMBER_WRONG = 'UPDATE_NUMBER_WRONG';
export const RESET_MOVE_INDEX = 'RESET_MOVE_INDEX';
